import styled from 'styled-components';

export const NavBarList = styled.ul`
  background-color: ${({ theme }) => theme.colors.panel.navigation.background};
  border-right: 1px solid ${({ theme }) => theme.colors.panel.navigation.border};
  width: 220px;
  height: 100%;
  padding: 0;
  margin: 0;
  padding-top: 20px;
  list-style: none;
  overflow-x: hidden;
  overflow-y: auto;

  & > * {
    padding-left: 44px;
    padding-top: 17px;
  }
`;

export const NavLinkItem = styled.li`
  padding-bottom: 4px;
  min-height: 48px;

  a {
    font-weight: ${(props) => (props.active ? 'bold' : 'normal')};
    color: inherit;
  }
`;

export const NavLinkSubText = styled.div`
  font-size: 78%;
`;

export const NavLinkIconContainer = styled.div`
  width: 20px;
  height: 20px;
  margin-left: -32px;
  float: left;

  svg {
    height: 100%;
    width: 100%;
  }
`;

export const NavLinkBadge = styled.div`
  background-color: ${({ theme }) => theme.colors.badge.background};
  position: relative;
  top: -8px;
  height: 17px;
  padding-top: 3px;
  display: inline-block;
  min-width: 10px;
  padding: 3px 7px;
  font-size: 12px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.badge.foreground};
  line-height: 1;
  vertical-align: baseline;
  white-space: nowrap;
  text-align: center;
  border-radius: 10px;
`;
